import { api } from 'src/tools/api';

// eslint-disable-next-line import/prefer-default-export
export const login = (email, password) => api.post('/user/auth', { email, password });
